<div class="cppOrderSummary">
  <div class="row">
    <div class="prepayContractOuter print-area" id="print-section">
      <div class="prepayContractTop">
        <div class="prepayContract">
          <div class="order-view-sec breadcrumbOuter padding-0 col-md-12">
          </div>
          <div class="row statusNotice" *ngIf="!showErrorItems">
            <div class="col-md-12">
              <span class="fontCondBold margin-r20">
                Status Notice:
              </span>
              {{statusNotice}}
            </div>
          </div>
          <div class="row errorSummary" *ngIf="showErrorItems">
            <div class="col-md-2 fontCondBold">
              Status Notice:
            </div>
            <div class="col-md-10">
              {{statusNotice}}
            </div>
          </div>
          <!-- <div class="row contract-info topMargin">

            <div class="col-md-12 padding-r0 col-10 mx-auto">
              <div class="row addressRow">
                <div class="col-md-3 col-lg-2 padding-l0">
                  <div class="row topMargin">
                    <div class="col-4 col-md-6 text-left">ORDER #:</div>
                    <div class="col-8 col-md-6 md-pl-10 xs-pl-10 text-left">
                      <span>{{webOrderNumber}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4  col-md-6  text-left">CREATED:</div>
                    <div class="col-4 col-md-6   md-pl-10 xs-pl-10 text-left">
                      <span>{{shipToAccountdetails.CreatedOn | date:'MM/dd/yyyy'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4 col-md-6  text-left">PLACED BY:</div>
                    <div class="col-8 col-md-6  md-pl-10 xs-pl-10 text-left">
                      <span>{{shipToAccountdetails.PlacedByName}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4 col-md-6  text-left padding-r0">CUSTOMER PO#:</div>
                    <div class="col-8 col-md-6  md-pl-10 xs-pl-10 text-left">
                      <span>{{shipToAccountdetails.CustomerPONumber}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-9 col-lg-10">
                  <div class="row">
                    <div class="col-md-4 md-pr-0">
                      <div class="row topMargin">
                        <div class="col-4 col-md-2 padding-0 text-left">SHIP TO:</div>
                        <div class="col-8 col-md-10 padding-l0 text-left">
                          <span>{{shipToAccountdetails.AccountName}}</span>
                          <span>{{shipToAccountdetails.Address1}}</span>
                          <span class="padding-r5">
                            {{shipToAccountdetails.AccountCity}} , {{shipToAccountdetails.AccountState}}
                            <span class="display-ib">{{shipToAccountdetails.AccountZipCode}}</span>
                          </span>
                        </div>
                      </div>
                      <div *ngIf="deliverToAccountdetails.AccountName" class="row topMargin">
                        <div class="col-4 col-md-2 padding-0 text-left">DELIVER TO:</div>
                        <div class="col-8 col-md-10 padding-l0 text-left">
                          <span *ngIf="deliverToAccountdetails.AccountName">{{deliverToAccountdetails.AccountName}}</span>
                          <span *ngIf="deliverToAccountdetails.Address1">{{deliverToAccountdetails.Address1}}</span>
                          <span *ngIf="deliverToAccountdetails.AccountCity">
                            {{deliverToAccountdetails.AccountCity}} , {{deliverToAccountdetails.AccountState}}
                            <span *ngIf="deliverToAccountdetails.AccountZipCode" class="margin-l5 display-ib">{{deliverToAccountdetails.AccountZipCode}}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div *ngIf="ascAccountDetails.AccountName" class="row topMargin">
                        <div class="col-4 col-md-2 padding-0 text-left">ASC:</div>
                        <div class="col-8 col-md-10 padding-0 text-left">
                          <span>{{ascAccountDetails.AccountName}}</span>
                          <span>{{ascAccountDetails.AscAddress1}}</span>
                          <span class="padding-r5">
                            {{ascAccountDetails.City}} , {{ascAccountDetails.State}}
                            <span class="display-ib">{{ascAccountDetails.ZipCode}}</span>
                          </span>

                          <div class="margin-t10">
                            <span>{{ascAccountDetails.Phone}}</span>
                            <span>{{ascAccountDetails.Email}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div *ngIf="dsmAccountDetails.AccountName" class="row topMargin">
                        <div class="col-4 col-md-2 text-left  xs-pl-0 xs-pr-0 md-pl-15 md-pr-15">DSM:</div>
                        <div class="col-8 col-md-10 md-pr-0 text-left   xs-pl-0 xs-pr-0 md-pl-15">
                          <span>{{dsmAccountDetails.AccountName}}</span>
                          <div class="margin-t10">
                            <span *ngIf="dsmAccountDetails.Email">{{dsmAccountDetails.Email}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-center justify-content-md-between align-items-center xs-ml-n15 xs-mt-30 md-mt-0 xs-mb-30 md-mb-0">
                <div class="d-flex align-items-center pdfText">
                  <span class="round-icon xs-mr-35 md-mr-15 mobile-round" (click)="generatePdf()">
                    <i class="far fa-file-pdf"></i>
                  </span>
                  View PDF to Print
                </div>
                <button mat-raised-button class="btns largeBtn d-none d-md-block d-lg-none" *ngIf="(showBackToCppLanding && !readOnlyAccess)" (click)="createNewOrder()">New Order</button>
              </div>
            </div>
          </div> -->
          <!-- -->
          <div class="row contract-info topMargin mx-auto">
            <div class="col-md xs-mb-15 md-mb-0">
              <p><span class="w-95">ORDER #: </span><strong><span data-testid="lbl-ordernumb">{{webOrderNumber}}</span></strong></p>
              <p>
                <span class="w-95">CREATED:</span><strong><span>{{shipToAccountdetails.CreatedOn | date:'MM/dd/yyyy'}}</span></strong>
              </p>
              <p>
                <span class="w-95">PLACED BY:</span><strong><span>{{shipToAccountdetails.PlacedByName}}</span></strong>
              </p>
              <p>
                <span class="w-95">
                  CUSTOMER
                  PO#:
                </span><strong><span>{{shipToAccountdetails.CustomerPONumber}}</span></strong>
              </p>
              <p *ngIf="isBulkItemAvailable">
                <span class="w-95">
                  BULK CONTACT NAME:
                </span><strong><span>{{pdfDataObject.bulkContactName}}</span></strong>
              </p>
              <p *ngIf="isBulkItemAvailable">
                <span class="w-95">
                  BULK CONTACT PHONE NUMBER:
                </span><strong><span>{{pdfDataObject.bulkContactNumber}}</span></strong>
              </p>
              <p *ngIf="packagedContactName"><span class="w-95">CONTACT NAME: </span><strong><span data-testid="lbl-ordernumb">{{packagedContactName}}</span></strong></p>
              <p *ngIf="packagedContactNumber"><span class="w-95">CONTACT PHONE NUMBER: </span><strong><span data-testid="lbl-ordernumb">{{packagedContactNumber}}</span></strong></p>
              <p *ngIf="packagedDeliveryInst"><span class="w-95">DELIVERY INSTRUCTIONS: </span><strong><span data-testid="lbl-ordernumb">{{packagedDeliveryInst}}</span></strong></p>
              <p *ngIf="contactEmailAddress"><span class="w-95">Non-Subscriber Email(s): </span><strong><span data-testid="lbl-ordernumb">{{contactEmailAddress}}</span></strong></p>
            </div>

            <div class="col-md xs-mb-15 md-mb-0" *ngIf="soldToAccountdetails.AccountName">
              <p>
                <span class="xs-w-95">SOLD TO:</span> <strong>
                  <span *ngIf="soldToAccountdetails.AccountNumber">{{soldToAccountdetails.AccountNumber}}</span>
                  <span *ngIf="soldToAccountdetails.AccountName">{{soldToAccountdetails.AccountName}}</span>
                  <span *ngIf="soldToAccountdetails.Address1">{{soldToAccountdetails.Address1}}</span>
                  <span *ngIf="soldToAccountdetails.Address1">{{soldToAccountdetails.Address2}}</span>
                  <span *ngIf="soldToAccountdetails.AccountCity">
                    {{soldToAccountdetails.AccountCity}} , {{soldToAccountdetails.AccountState}}
                    <span *ngIf="soldToAccountdetails.AccountZipCode"
                          class="margin-l5 display-ib">{{soldToAccountdetails.AccountZipCode}}</span>
                  </span>
                  <span *ngIf="soldToAccountdetails.RepackAgreement"
                        class="margin-l5 display-ib">{{soldToAccountdetails.RepackAgreement}}</span>
                </strong>
              </p>
            </div>

            <div class="col-md xs-mb-15 md-mb-0">
              <p>
                <span class="xs-w-95">SHIP TO:</span> <strong>
                  <span>{{shipToAccountdetails.AccountNumber}}</span>
                  <span>{{shipToAccountdetails.AccountName}}</span>
                  <span>{{shipToAccountdetails.Address1}}</span>
                  <span>{{shipToAccountdetails.Address2}}</span>
                  <span class="padding-r5">
                    {{shipToAccountdetails.AccountCity}} , {{shipToAccountdetails.AccountState}}
                    <span class="display-ib">{{shipToAccountdetails.AccountZipCode}}</span>
                  </span>
                </strong>
              </p>
            </div>

            <div class="col-md xs-mb-15 md-mb-0" *ngIf="deliverToAccountdetails.AccountName">
              <p>
                <span class="xs-w-95">DELIVER TO:</span> <strong>
                  <span *ngIf="deliverToAccountdetails.AccountNumber">{{deliverToAccountdetails.AccountNumber}}</span>
                  <span *ngIf="deliverToAccountdetails.AccountName">{{deliverToAccountdetails.AccountName}}</span>
                  <span *ngIf="deliverToAccountdetails.Address1">{{deliverToAccountdetails.Address1}}</span>
                  <span *ngIf="deliverToAccountdetails.AccountCity">
                    {{deliverToAccountdetails.AccountCity}} , {{deliverToAccountdetails.AccountState}}
                    <span *ngIf="deliverToAccountdetails.AccountZipCode"
                          class="margin-l5 display-ib">{{deliverToAccountdetails.AccountZipCode}}</span>
                  </span>
                </strong>
              </p>
            </div>

            <!--<div class="col-md xs-mb-15 md-mb-0" *ngIf="ascAccountDetails.AccountName">
              <p>
                <span class="xs-w-95">ASC:</span> <strong>
                  <span>{{ascAccountDetails.AccountName}}</span>
                  <span>{{ascAccountDetails.AscAddress1}}</span>
                  <span class="padding-r5">
                    {{ascAccountDetails.City}} , {{ascAccountDetails.State}}
                    <span class="display-ib">{{ascAccountDetails.ZipCode}}</span>
                  </span>

                  <div class="margin-t10">
                    <span>{{ascAccountDetails.Phone}}</span>
                    <span>{{ascAccountDetails.Email}}</span>
                  </div>
                </strong>
              </p>
            </div>-->

            <div class="col-md xs-mb-15 md-mb-0" *ngIf="dsmAccountDetails.AccountName">
              <p>
                <span class="xs-w-95">AM:</span>
                <strong>
                  <span>{{dsmAccountDetails.AccountName}}</span>
                  <div class="margin-t10">
                    <span *ngIf="dsmAccountDetails.Email">{{dsmAccountDetails.Email}}</span>
                  </div>
                </strong>
              </p>
            </div>
          </div>

          <div class="row margin-t10 no-gutters contract-info">
            <div class="text-center text-md-left xs-mb-20 md-mb-0 col-md-2 padding-l0 pdfText">
              <span class="md-ml-15 round-icon xs-mr-35 md-mr-15 mobile-round" (click)="generatePdf()">
                <i class="far fa-file-pdf"></i>
              </span>
              View PDF to Print
            </div>
            <div class="col-md-8 text-center diclaimermsg">
              <div>{{this.disclaimerMessage}}</div>
              <div>{{this.dynamicDisclaimerMessage}}</div></div>
            <div class="d-none d-sm-none d-md-block col-md-2 text-right">
              <button mat-raised-button class="btns largeBtn" *ngIf="(!isRedirectedFromSraOrder && showBackToCppLanding && !readOnlyAccess)" (click)="createNewOrder()">New Order</button>
            </div>
          </div>

          <div class="row contract-info topMargin" *ngIf="isInstructionType">
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">INSTRUCTION TYPE</div>
              </div>
              <div class="row">
                <div class="col-md-12"><span>{{shipToAccountdetails.InstructionType}}</span></div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">SPECIAL INSTRUCTION DETAIL</div>
              </div>
              <div class="row">
                <div class="col-md-12"><span>{{shipToAccountdetails.HeaderText}}</span></div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">CUSTOMER PICK UP</div>
              </div>
              <div class="row">
                <div class="col-md-12"><span>{{shipToAccountdetails.CustomerPickUp}}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="prepayContBottom">
        <div class="prepayContract topMargin">
          <div>
            <button mat-raised-button class="btns largeBtn d-block d-sm-block d-md-none xs-full-width xs-button" *ngIf="(showBackToCppLanding && !readOnlyAccess)" (click)="createNewOrder()">New Order</button>
            <div class="OrderReleaseDetail">
              <div class="row">
                <div class="col-md-12 productTableOuter productMargin padding-0" *ngIf="cppProductItemsDataSource && cppProductItemsDataSource.length">
                  <div *ngFor="let item of cppProductItemsDataSource; let i=index">
                    <div>
                      <div class="row" *ngIf="item.hasError">
                        <div class="col-md-12">
                          <button class=" textAlignment errorSummary">{{getErrorMessagesForProduct()}}</button>
                        </div>
                      </div>
                      <div class="row  margin-t20 margin-b10 xs-status-row">
                        <div class="col-12">
                          <span [attr.data-testid]="lblShippingInstruction"><b [attr.data-testid]="'lbl-shipping-instruction_'+(i+1)">Shipping Instructions: {{specialInstructionText}}</b></span>
                        </div>
                      </div>
                      <div class="row  margin-t20 margin-b10 xs-status-row">
                        <div class="col-md-3">
                          <span [attr.data-testid]="'lbl-ordernumbsplit_'+(i+1)"><b [attr.data-testid]="'lbl-ordernumber-split_'+(i+1)">Order ID: {{webOrderNumber}}-{{item.splitId}}</b></span>
                        </div>
                        <div class="col-md-3">
                          <!--<span *ngIf="!isRedirectedFromPlacedOrder && item.jdeorderNumber" (click)="NavigateToOTISummaryPage(item.jdeorderNumber)"><b>Sales Order Number: {{item.jdeorderNumber}}</b></span>-->
                          <span *ngIf="!isRedirectedFromPlacedOrder && item.jdeorderNumber && item.isAvailableInOTIHeader">
                            <b>
                              Sales Order Number:
                              <a style="text-decoration:underline" [routerLink]="[]" (click)="NavigateToOTISummaryPage(item.jdeorderNumber, item.orderType)">
                                {{item.jdeorderNumber}}
                              </a>
                            </b>
                          </span>
                        </div>
                        <div class="col-md-3">
                          <span *ngIf="!isRedirectedFromPlacedOrder"><b>Status: <button [ngClass]="item.orderStatus =='ERROR' ? 'redstatusBtn' : 'statusBtn'">{{item.orderStatus}}</button></b></span>
                        </div>
                        <div class="col-md-3">
                          <span class="float-md-right" *ngIf="getDeliveryDate(item) && getDeliveryDateReason(item)"><b [attr.data-testid]="'lbl-arrival-date-split_'+(i+1)">Requested Arrival Date: <u matTooltip="{{getTooltipText(item)}}" matTooltipClass="dateTooltip" [matTooltipPosition]="'above'">{{getDeliveryDate(item) | date:'MM/dd/yyyy'}}</u></b></span>
                          <span class="float-md-right" *ngIf="getDeliveryDate(item) && !getDeliveryDateReason(item)"><b [attr.data-testid]="'lbl-arrival-date-split_'+(i+1)">Requested Arrival Date: {{getDeliveryDate(item) | date:'MM/dd/yyyy'}} </b></span>
                        </div>
                      </div>
                    </div>
                    <div class="tableContainer summaryPage botMargin table-mobile">
                      <app-cpp-grid-view [gridData]="item" [itemSplitIndex]="(i+1)" [itemSplitId]="item.splitId"></app-cpp-grid-view>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="prepayBtnSec footer-action-button">
        <div class="row">
          <div class="col-md-12">
            <button mat-raised-button class="btns xs-button xs-full-width" *ngIf="showBackToCppLanding" (click)="backToLandingPage()">Back To Order List</button>
            <button mat-raised-button class="btns xs-button xs-full-width" *ngIf="!showBackToCppLanding" (click)="backToErrorMaintenancePage()">Back To Error Order List</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
